export const PATTERN_STYLE_OPTIONS = [
    { label: 'Flat Design', value: 'flat_design' },
    { label: 'Sleek & Modern', value: 'sleek_and_modern' },
    { label: 'Bold & Colorful', value: 'bold_and_colorful' },
    { label: 'Elegant', value: 'elegant' },
    { label: 'Conservative & Traditional', value: 'conservative_and_traditional' },
    { label: 'Geometric', value: 'geometric' },
    { label: 'Monochromatic', value: 'monochromatic' },
    { label: 'Neo Memphis', value: 'neo_memphis' },
    { label: 'Surrealist', value: 'surrealist' },
    { label: 'Maximalist', value: 'maximalist' },
    { label: 'Pop Art', value: 'pop_art' },
    { label: 'Doodle', value: 'doodle' },
    { label: 'Cultural', value: 'cultural' },
    { label: 'Organic', value: 'organic' },
    { label: 'Playful', value: 'playful' },
    { label: 'Watercolor', value: 'watercolor' },
    { label: 'Illustrative', value: 'illustrative' },
    { label: 'Retro', value: 'retro' },
    { label: 'Vintage', value: 'vintage' },
    { label: 'Minimal', value: 'minimal' },
    { label: 'Bauhaus', value: 'bauhaus' },
    { label: 'Folk', value: 'folk' },
    { label: 'Retro Vintage', value: 'retro_vintage' },
] as const;
